<template>
    <div class="container-index">
        <NavbarHeader />
        <LeftMenu />
        <ButtonsFooter />
        <LoadingScreen
            v-if="loadingHydro || loadingAccele || loadingPhrea || loadingAirq"
            :hydro="loadingHydro"
            :accele="loadingAccele"
            :phrea="loadingPhrea"
            :airq="loadingAirq"
        />
        <ErrorScreen v-if="error" />
        <LeafletMap />
        <StationMenu v-if="showMenu" />
    </div>
</template>

<script>
    import NavbarHeader from '@/views/NavbarHeader/NavbarHeader.vue';
    import LeftMenu from '@/views/LeftMenu/LeftMenu.vue';
    import ButtonsFooter from '@/views/ButtonsFooter/ButtonsFooter.vue';
    import LeafletMap from '@/views/LeafletMap/LeafletMap.vue';
    import StationMenu from '@/views/StationMenu.vue';
    import LoadingScreen from './LoadingScreen/LoadingScreen.vue';
    import ErrorScreen from './ErrorScreen.vue';

    import {mapState} from 'vuex';

    export default {
        name: 'InitialPage',

        components: {
            NavbarHeader,
            LeftMenu,
            ButtonsFooter,
            LeafletMap,
            StationMenu,
            LoadingScreen,
            ErrorScreen
        },

        computed:{
            ...mapState('station_id',['loadingHydro','loadingAccele','loadingPhrea','loadingAirq','showMenu','error'])
        }
    };
</script>

<style scoped>
    .container-index{
        height: 100%;
        width: 100%;
    }
</style>